//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { InstagramReelsPostCustomizations } from '@bvengineering/universal-scheduling-gateway-service-types';

export type InstagramReelsCreativeNotesType = keyof Omit<
  InstagramReelsPostCustomizations,
  'caption' | 'location' | 'userTags'
>;

export const OrderedInstagramReelsCreativeNotesTypes: readonly InstagramReelsCreativeNotesType[] =
  ['textOverlay', 'audio', 'effects', 'stickers', 'other'] as const;

export const InstagramReelsCreativeNotesTypeLabel: Record<
  InstagramReelsCreativeNotesType,
  string
> = {
  audio: 'Audio',
  effects: 'Effects',
  other: 'Other',
  stickers: 'Stickers',
  textOverlay: 'Text Overlay',
} as const;

export const REELS_CREATIVE_NOTES_SECTION_TOOLTIP_TEXT = {
  Manual: `Notes help you keep track of any text overlays, audio, effects, stickers, locations tags, or other details that you'll want to add to your Reels post. We'll make it easy to copy and paste your notes when it's time to post.`,
  Auto: `Some customization options, like audio naming, are not available when automatically posting.`,
};

export interface ICreativeNotesFormFieldInfo {
  label: string;
  placeholderText: string;
}

export const creativeNotesFormFieldInfo: Record<
  InstagramReelsCreativeNotesType,
  ICreativeNotesFormFieldInfo
> = {
  audio: {
    label: InstagramReelsCreativeNotesTypeLabel.audio,
    placeholderText:
      'Enter the name of the audio to be used to your Reels post',
  },
  effects: {
    label: InstagramReelsCreativeNotesTypeLabel.effects,
    placeholderText: 'Enter the effect you want to add to your Reels post',
  },
  stickers: {
    label: InstagramReelsCreativeNotesTypeLabel.stickers,
    placeholderText: 'Enter the sticker you want to add to your Reels post',
  },
  textOverlay: {
    label: InstagramReelsCreativeNotesTypeLabel.textOverlay,
    placeholderText: 'Enter the text you want to overlay to your Reels post',
  },
  other: {
    label: InstagramReelsCreativeNotesTypeLabel.other,
    placeholderText: 'Enter any additional reminders for your Reels post',
  },
} as const;
